import SmallLogo from '@/assets/logos/SmallLogo';
import ContactUsModal from '@/components/LayoutTools/Header/ContactUsModal';
import CustomerSupportModal from '@/components/LayoutTools/Header/CustomerSupportModal';
import Logo from '@/components/LayoutTools/Header/Logo';
import PrivacyPolicyDialog from '@/components/PageSpecific/privacy-policy/PrivacyPolicyDialog';
import TermsOfUseDialog from '@/components/PageSpecific/terms-of-use/TermsOfUseDialog';
import {
  NavSectionMini,
  NavSectionVertical,
} from '@/components/version2/nav-section';
import { Scrollbar } from '@/components/version2/scrollbar';
import { IS_ETS_NEXT } from '@/utils/constants';
import { hideScrollY } from '@/utils/version2/theme/styles';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import moment from 'moment-timezone';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { NavToggleButton } from '../components/nav-toggle-button';
// ----------------------------------------------------------------------

export function NavVertical({
  sx,
  data,
  slots,
  isNavMini,
  layoutQuery,
  onToggleNav,
  ...other
}) {
  const theme = useTheme();
  const router = useRouter();
  const [customerSupportModalOpen, setCustomerSupportModalOpen] =
    useState(false);
  const [contactUSModalOpen, setContactUSModalOpen] = useState(false);
  const [openTOU, setOpenTOU] = useState(false);
  const [openPP, setOpenPP] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const closeMenu = () => {
    setAnchorEl(null);
  };

  const openCustomerSupportModal = () => {
    closeMenu();
    setCustomerSupportModalOpen(true);
  };

  const openContactUSModal = () => {
    closeMenu();
    setContactUSModalOpen(true);
  };

  const goToHubReleases = () => {
    router.push('/personal-settings/hub-releases');
  };

  const renderNavfooter = (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant='body1'
          color='textSecondary'
          onClick={() => openContactUSModal()}
          sx={{
            width: '100%',
            height: '20%',
            '&:hover': {
              backgroundColor: '#e5eff7',
              cursor: 'pointer',
            },
          }}
        >
          <ContactSupportOutlinedIcon
            className={'navSectionClasses.item.icon'}
            sx={{ px: 5, pt: 1 }}
          />
          {!isNavMini && <span style={{ marginBottom: 3 }}>Contact Us</span>}
        </Typography>
        {!IS_ETS_NEXT && (
          <Typography
            variant='body1'
            color='textSecondary'
            onClick={goToHubReleases}
            sx={{
              width: '100%',
              height: '20%',
              '&:hover': {
                backgroundColor: '#e5eff7',
                cursor: 'pointer',
              },
            }}
          >
            <TextSnippetIcon sx={{ px: 5, pt: 1 }} />
            {!isNavMini && (
              <span style={{ marginBottom: 3 }}>Release Notes</span>
            )}
          </Typography>
        )}
        <Divider />
        {!isNavMini && (
          <Box
            sx={{
              width: '80%',
              margin: '1rem auto',
              textAlign: 'center',
              border: 1,
              borderRadius: 1,
            }}
          >
            <Button color='inherit' onClick={() => openCustomerSupportModal()}>
              Give Feedback
            </Button>
          </Box>
        )}
        {!isNavMini && (
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Grid container>
              <Grid item xs={1}></Grid>
              <Grid item xs={12} md={2}>
                <Typography variant='caption'>
                  v: {process.env.NEXT_PUBLIC_VERSION}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  color='inherit'
                  onClick={() => setOpenTOU(true)}
                  sx={{
                    fontSize: '10px',
                  }}
                >
                  Terms of Use
                </Button>
              </Grid>
              <Grid item xs={12} md={4}>
                <Button
                  color='inherit'
                  onClick={() => setOpenPP(true)}
                  sx={{
                    fontSize: '10px',
                  }}
                >
                  Privacy Policy
                </Button>
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </Box>
        )}
        {isNavMini && (
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography variant='caption'>
              v: {process.env.NEXT_PUBLIC_VERSION}
            </Typography>
            <Button
              color='inherit'
              onClick={() => setOpenTOU(true)}
              sx={{
                fontSize: '10px',
              }}
            >
              Terms of Use
            </Button>
            <Button
              color='inherit'
              onClick={() => setOpenPP(true)}
              sx={{
                fontSize: '10px',
              }}
            >
              Privacy Policy
            </Button>
          </Box>
        )}
        <Typography
          sx={{
            margin: 2,
            fontSize: '10px',
          }}
        >
          © {moment().year()} Cornerstone Information Systems, Inc.
        </Typography>
      </Box>
      <CustomerSupportModal
        isOpen={customerSupportModalOpen}
        onClose={() => setCustomerSupportModalOpen(false)}
      />
      <ContactUsModal
        isOpen={contactUSModalOpen}
        onClose={() => setContactUSModalOpen(false)}
      />

      <TermsOfUseDialog open={openTOU} setOpen={setOpenTOU} />
      <PrivacyPolicyDialog open={openPP} setOpen={setOpenPP} />
    </>
  );

  const renderNavVertical = (
    <>
      <Box sx={{ pl: 3.5, pt: 2.5, pb: 1 }}>
        <Logo />
      </Box>

      <Scrollbar fillContent>
        <NavSectionVertical
          data={data}
          sx={{
            px: 0,
            flex: '1 1 auto',
            maxHeight: '250px',
            overflowY: 'auto',
          }}
          {...other}
        />
      </Scrollbar>
    </>
  );

  const renderNavMini = (
    <>
      {slots?.topArea ?? (
        <Box
          sx={{
            height: '100px',
            display: 'flex',
            justifyContent: 'center',
            py: 2.5,
          }}
        >
          <SmallLogo />
        </Box>
      )}

      <NavSectionMini
        data={data}
        sx={{
          pb: 2,
          px: 0.5,
          ...hideScrollY,
          flex: '1 1 auto',
          overflowY: 'auto',
        }}
        {...other}
      />

      {slots?.bottomArea}
    </>
  );

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        height: 1,
        display: 'none',
        position: 'fixed',
        flexDirection: 'column',
        bgcolor: 'var(--layout-nav-bg)',
        zIndex: 'var(--layout-nav-zIndex)',
        width: isNavMini
          ? 'var(--layout-nav-mini-width)'
          : 'var(--layout-nav-vertical-width)',
        borderRight: `1px solid var(--layout-nav-border-color, ${theme.palette.grey.main})`,
        transition: theme.transitions.create(['width'], {
          easing: 'var(--layout-transition-easing)',
          duration: 'var(--layout-transition-duration)',
        }),
        [theme.breakpoints.up(layoutQuery)]: {
          display: 'flex',
        },
        ...sx,
      }}
    >
      <NavToggleButton
        isNavMini={isNavMini}
        onClick={onToggleNav}
        sx={{
          display: 'none',
          [theme.breakpoints.up(layoutQuery)]: {
            display: 'inline-flex',
          },
        }}
      />
      {isNavMini ? renderNavMini : renderNavVertical}
      {renderNavfooter}
    </Box>
  );
}
